import { Route } from 'react-router-dom'
import DefaultRedirect from 'screens/Groups/Home/components/DefaultRedirect'
import HomeBMICharts from 'screens/Groups/Home/components/HomeBMICharts'
import HomeDashboard from 'screens/Groups/Home/components/HomeDashboard'
import HomeIncidents from 'screens/Groups/Home/components/HomeIncidents'
import HomeProfile from 'screens/Groups/Home/components/HomeProfile'
import HomeProfileEdit from 'screens/Groups/Home/components/HomeProfileEdit'
import GroupHome from 'screens/Groups/Home'
import { ID, PROFILE } from './utils'

const HOMES_PATH = 'homes'
export const HOMES = {
  INDEX: HOMES_PATH,
  PROFILE: `${HOMES_PATH}/${ID}/${PROFILE}`,
  EDIT: `${HOMES_PATH}/${ID}/edit`,
  DASHBOARD: `${HOMES_PATH}/${ID}/dashboard`,
  INCIDENTS: `${HOMES_PATH}/${ID}/incidents`,
  BMI: `${HOMES_PATH}/${ID}/bmi`,
}

export const homesRoutes = (
  <Route path={HOMES_PATH} element={<GroupHome />}>
    <Route index element={<DefaultRedirect listId="homes" />} />
    <Route path={`${ID}/${PROFILE}`} element={<HomeProfile />} />
    <Route path={`${ID}/edit`} element={<HomeProfileEdit />} />
    <Route path={`${ID}/dashboard`} element={<HomeDashboard />} />
    <Route path={`${ID}/incidents`} element={<HomeIncidents />} />
    <Route path={`${ID}/bmi`} element={<HomeBMICharts />} />
  </Route>
)
